import hasFloatValidDigits from '~/utils/Number/hasFloatValidDigits';

export default function isValidPriceValue(value: number): boolean {
	return value > 0 && hasFloatValidDigits(value, 17, 10);
}
